import { createFileRoute } from "@tanstack/react-router";
import { PageHero, Eyebrow, ServiceGrid, HowItWorks, FinalCta } from "@/components/sections";
import { pageHead, breadcrumbLd } from "@/lib/seo";

const TITLE = "Mobile Auto Repair Services Great Falls MT | 406 Mobile Mechanic";
const DESC = "All mobile auto repair services from 406 Mobile Mechanic in Great Falls, MT — diagnostics, brakes, electrical, AC, towing and more. Call or text 406-799-0095.";

export const Route = createFileRoute("/services/")({
  head: () => pageHead("/services", TITLE, DESC, [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Services", path: "/services" }])]),
  component: ServicesPage,
});

function ServicesPage() {
  return (
    <main>
      <PageHero
        crumbs={[{ label: "Home", to: "/" }, { label: "Services" }]}
        eyebrow="What we fix · Great Falls, MT"
        title={<>Mobile Auto Repair Services in <span className="text-primary">Great Falls, MT</span></>}
        intro="A mobile mechanic saves you the tow, the ride, and the afternoon in a shop waiting room. Josh brings the tools and parts to your driveway, job site or roadside and fixes it where it sits."
        photo="truck"
      />
      <section className="topo bg-charcoal-deep py-24" aria-labelledby="all-services-h">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <Eyebrow>12 services</Eyebrow>
          <h2 id="all-services-h" className="mt-4 max-w-3xl text-5xl font-black md:text-6xl">Everything We Handle On Site</h2>
          <p className="mt-5 max-w-2xl text-foreground/85">Not sure which one you need? Call or text with your vehicle and what's going on — Josh will tell you straight.</p>
          <ServiceGrid />
        </div>
      </section>
      <HowItWorks />
      <FinalCta title={<>Need a mechanic? <span className="text-primary">We come to you.</span></>} />
    </main>
  );
}
